/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAOffIcon32Regular = forwardRef('MediaAudioVolumeAOffIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.586 10 3.293 4.707a1 1 0 0 1 1.414-1.414l24 24a1 1 0 0 1-1.414 1.414L23 24.414v2.63c0 1.745-2.078 2.654-3.359 1.468L12.608 22H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1.586ZM21 22.414v4.63l-7.033-6.512A2 2 0 0 0 12.608 20H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3.586L21 22.414Z" }),
        React.createElement("path", { d: "M21 4.955v11.57l2 2V4.955c0-1.745-2.078-2.653-3.359-1.467l-6.064 5.614 1.416 1.416L21 4.955Z" })));
});
